/*
 * @Desc: 导航
 * @Author: zcc
 * @Date: 2022-11-16 11:02:08
 * @LastEditors: zhangyi zhangy.cosmo@haier.com
 * @LastEditTime: 2023-12-08 10:40:46
 */
const nav = [
  {
    title: '基础服务',
    children: [
      {
        path: 'https://www.cosmoplat.com/choice?solutionId=1724663784643297282',
        title: '数字化能力测评',
        desc: '通过数字化人才评估、企业数字化转型诊断，挖掘个人能力、定位企业转型痛点的产品'
      },
      {
        path: 'https://www.cosmoplat.com/choice?solutionId=1682270744875106305',
        title: '物联开发平台',
        desc: '为企业提供统一的工业物联基座，南向集成工业多源设备数据，北向集成多场景应用，满足企业定制化、集成化和智能化业务需求，提供面向不同行业的物联解决方案。'
      },
      {
        path: 'https://www.cosmoplat.com/choice?solutionId=1684023995751137282',
        title: '时序数据库',
        desc: '针对时间序列数据收集、存储与分析一体化的数据管理引擎。它具有体量轻、性能高、易使用的特点，适用于工业互联网应用中海量时间序列数据高速写入和复杂分析查询的需求'
      },
      {
        path: 'https://www.cosmoplat.com/choice?solutionId=1680773875148750849',
        title: '工业容器云',
        desc: '运用容器引擎、编排调度引擎、DevOps等云原生技术,搭建的可提供横向扩展、秒级伸缩、智能运维、适应快速开发持续交付的PaaS级云平台'
      },
      
    ]
  },
  {
    title: '大数据&人工智能',
    children: [
      {
        path: 'https://baas.cosmoplat.com/bi',
        title: '工业大脑-BI服务',
        desc: '提高数据分析效率，降低数据分析成本，帮助企业搭建卓越的大数据分析平台，助力企业实现智慧化数据运营。'
      },
      {
        title: '工业大脑-机理模型平台',
        desc: '汇集了工业领域生产过程中的原理、定理、定律等专业知识，结合了实际工业生产经验，形成机理并构建成可解释的模型，嵌入到工业互联网平台中',
        path: 'https://baas.cosmoplat.com/mechanism-model'
      },
      {
        title: '工业大脑-AI平台',
        desc: '为算法人员提供端到端的算法研发工具。围绕AI开发过程中所需要数据处理、模型训练等业务需求提供一站式服务，推动算法技术进步。',
        path: 'https://www.cosmoplat.com/choice?solutionId=1681925571964043265'
      },
      {
        title: '大数据管理服务',
        desc: '一款面向企业的全场景、低门槛、开放灵活的大数据管理与分析平台，可一站式完成数据集成、数据开发、数据治理、数据分析、数据服务，实现采、存、管、用一体化，帮助企业实现数据价值释放',
        path: 'https://baas.cosmoplat.com/big-data'
      }
    ]
  },
  {
    title: '工业应用开发',
    children: [
      {
        title: '区块链服务',
        desc: '平台集成了自研、长安链、 Fabric等主流区块链底层引擎，极大降低区块链接入成本，简化构建部署流程。同时为用户提供溯源、存证、信息共享、供应链管理以及通证发行等解决方案',
        path: 'https://baas.cosmoplat.com/blockchain'
      },
      {
        path: 'https://www.cosmoplat.com/choice?solutionId=1549236594053566465',
        title: '低代码开发平台',
        desc: '一款以低代码为核心特性的工业行业数字化应用搭建平台，致力于帮助工业行业用户以低成本、短周期、高效率的方式实现工业行业各类数字化应用'
      },
      {
        title: '电签服务',
        desc: '招标、在线范本管理、签订、归档全流程线上化、智能履约&预警，以区块链技术加密存档，助力企业合同全流程管理、风险规避、降本增效',
        path: 'https://www.cosmoplat.com/choice?solutionId=1680857727456215041',
      },
      {
        title: 'COSMOPlat支付系统',
        desc: 'COSMOPlat支付系统致力于为用户提供丰富的支付渠道,体验安全、快捷、方便、多样的支付方式',
        path: 'https://www.cosmoplat.com/choice?solutionId=1681200770440986625',
      },
      {
        title: '标识体系应用服务平台',
        desc: '将标识注册、标识存储、标识解析、标识管理等能力标准化，让企业能够快速接入标识解析体系，推动标识体系在工业互联网的应用。',
        path: 'https://baas.cosmoplat.com/identity-resolution',
      },
      {
        title: '统一用户中心',
        desc: '统一用户中心管理平台是企业信息化、大数据背景下必须建设的基础应用之一， 通常具有统一用户、统一鉴权、授权登录、开放接口、用户行为分析等功能，对外提供用户基础服务。',
        path: 'https://www.cosmoplat.com/choice?solutionId=1680853622348283906',
      }
    ]
  },
  {
    title: '集成运维',
    children: [
      {
        title: '数据库管理系统',
        desc: '数据库管理系统是一款数据库全生命周期管理软件，集数据库申请&退订，数据库监控告警、数据库改配、数据库审计、SQL查询、SQL执行&回退、审批流、SQL分析、SQL检测、SQL执行计划、SQL美化等功能为一身，为用户提供一站式服务的数据库综合管理平台。',
        path: 'https://www.cosmoplat.com/choice?solutionId=1680819170352005122'
      },
      {
        title: 'DevOps(开发者平台)',
        desc: 'DevOps流水线平台是一组自动化流程，使 DevOps 专业人员和开发人员能够可靠而有效地编译，构建并将其代码部署到生产计算平台。',
        path: 'https://www.cosmoplat.com/choice?solutionId=1680843166447534082'
      },
      {
        title: '代码管理平台',
        desc: '代码管理平台是一站式软件研发管理协作平台，提供Git 代码托管、项目协同、持续开发、持续集成等一系列能力 ，帮助研发团队快速落地敏捷开发与DevOps 开发方式，提升研发管理效率，实现研发效能升级。',
        path: 'https://www.cosmoplat.com/choice?solutionId=1680844384192397314'	
      },
      
    ]
  },
  {
    title: '开发者中心',
    children: [
      {
        path: 'https://baas.cosmoplat.com/open-api',
        title: 'OpenAPI',
        desc: 'API全生命周期管理服务平台'
      },
      {
        title: '开源社区',
        desc: '工业互联网开源社区生态平台',
        path: 'https://openlab.cosmoplat.com/'
      },
      {
        title: '开源项目',
        desc: '一站式代码托管服务',
        path: 'https://openlab.cosmoplat.com/project'
      },
      {
        title: '大赛活动',
        desc: '热门开发者活动、开源竞赛',
        path: 'https://openlab.cosmoplat.com/match-index'
      },
      {
        title: '低代码开发',
        desc: '工业行业数字化应用搭建平台',
        path: 'https://lcode.cosmoplat.com/#/'
      },
      // {
      //   title: '智能视觉',
      //   desc: '低门槛、低成本的AI视觉服务',
      //   path: 'https://baas.cosmoplat.com/intelligent-vision'
      // }
    ]
  }
]
export default nav
